// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyCVyCErzf5mEJBDCCsQMkI0fAV3nTS39p0",
    authDomain: "vuyapp-proyecto.firebaseapp.com",
    databaseURL: "https://vuyapp-proyecto.firebaseio.com",
    projectId: "vuyapp-proyecto",
    storageBucket: "",
    messagingSenderId: "821869491168"
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts